"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/no-unused-class-component-methods */
/* eslint-disable no-param-reassign */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unused-prop-types */
const react_1 = __importDefault(require("react"));
const three_1 = require("three");
const tween_js_1 = __importStar(require("@tweenjs/tween.js"));
const consts_1 = require("~/store/consts");
const types_1 = require("~/store/types");
const events_1 = require("~/utils/events");
// eslint-disable-next-line import/no-cycle
const utils_3d_1 = require("~/components/Cad3d/utils/utils.3d");
const utils_1 = require("~/utils/utils");
const events_2 = require("~/consts/events");
const consts_2 = require("./consts/consts");
const AnchorDetection_3d_1 = __importStar(require("./classes/AnchorDetection.3d"));
const classes_1 = require("./classes");
const consts_3 = require("./consts");
const Cad3d_scss_1 = __importDefault(require("./Cad3d.scss"));
const utils_2 = require("./utils");
const FpsCounter_1 = __importDefault(require("./utils/FpsCounter"));
const Logger_1 = __importDefault(require("./utils/Logger"));
const commands_1 = require("./commands");
const SlicingTool_3d_1 = __importDefault(require("./classes/SlicingTool.3d"));
const PointToPointMeasureTool_3d_1 = __importDefault(require("./classes/PointToPointMeasureTool.3d"));
const ConnectionManager_3d_1 = __importDefault(require("./classes/ConnectionManager.3d"));
const FastenersUtils_1 = require("./utils/FastenersUtils");
const FastenerPreviewHelper_3d_1 = __importDefault(require("./classes/FastenerPreviewHelper.3d"));
const BomBalloonsManagerV2_1 = __importDefault(require("./classes/BOMBalloons/BomBalloonsManagerV2"));
const PlasticPanelCutouts_3d_1 = require("./classes/PlasticPanelCutouts.3d");
const screenshots_1 = __importDefault(require("./utils/screenshots"));
const ScreenShotManager_1 = require("./classes/ScreenShots/ScreenShotManager");
const ViewerTestBridge_1 = require("./ViewerTestBridge");
const panCursor = "url('/assets/cursors/cursor-camera-pinch.cur') 8 8, default";
const rotateCursor = "url('/assets/cursors/cursor-camera-rotate.cur') 8 8, default";
// Temp objects to use in functions, which are called on every render or just very often
// This made to prevent ineffective object creation
const tempPlane = new three_1.Plane();
const tempVector1 = new three_1.Vector3();
const tempVector2 = new three_1.Vector3();
const tempQuaternion = new three_1.Quaternion();
const tempLine = new three_1.Line3();
class Viewer extends react_1.default.Component {
    reportProjectLoadingStage(stage) {
        return __awaiter(this, void 0, void 0, function* () {
            this.props.setProjectLoadingStage(stage);
            yield new Promise((resolve) => {
                requestAnimationFrame(() => {
                    resolve();
                });
            });
        });
    }
    // eslint-disable-next-line react/sort-comp
    get isImperialMeasurementUsed() {
        // eslint-disable-next-line no-underscore-dangle
        return this._isImperialMeasurementUsed;
    }
    set isImperialMeasurementUsed(val) {
        // eslint-disable-next-line no-underscore-dangle
        this._isImperialMeasurementUsed = val;
    }
    get selectedObjects() {
        return this.designProMain.selectionTool.selectedObjects;
    }
    get selectedObjectUUIDs() {
        return this.designProMain.selectionTool.selectedObjectsUuids;
    }
    get selectedObjectsByType() {
        var _a, _b;
        return (_b = (_a = this.designProMain) === null || _a === void 0 ? void 0 : _a.selectionTool) === null || _b === void 0 ? void 0 : _b.selectedObjectsByType;
    }
    get masterPart() {
        return this.designProMain.selectionTool.getMasterPart();
    }
    constructor(props) {
        super(props);
        this.raycaster = new three_1.Raycaster();
        this.mouse = new three_1.Vector2();
        this.mouseDown = false;
        this.fastenerHoverHelper = new classes_1.FastenerHoverHelper();
        // mouse data
        this.rotateStart = new three_1.Vector2();
        this.rotateEnd = new three_1.Vector2();
        this.rotateDelta = new three_1.Vector2();
        this.rotationCenterFound = false;
        this.boundDevKeyDown = null;
        this.currentGridScaleState = -1;
        // eslint-disable-next-line react/no-unused-class-component-methods
        this.viewCubeEventsEnabled = true;
        this._isImperialMeasurementUsed = true;
        this.init = () => {
            var _a;
            const canvasViewer = this.getRendererDOMElement();
            this.scene = new three_1.Scene();
            this.scene.background = new three_1.Color(consts_3.consts.DEFAULT_GRID_BACKGROUND_COLOR);
            // init Camera
            const cameraPosition = new three_1.Vector3(consts_3.consts.DEFAULT_CAMERA_POSITION.x, consts_3.consts.DEFAULT_CAMERA_POSITION.y, consts_3.consts.DEFAULT_CAMERA_POSITION.z);
            this.camera = new classes_1.Camera(cameraPosition, this.scene.position);
            this.camera.setZoom(consts_3.consts.DEFAULT_CAMERA_ZOOM);
            this.camera.matrixAutoUpdate = true;
            this.backgroundPlane = new three_1.Mesh(new three_1.PlaneGeometry(consts_3.consts.DEFAULT_GRID_SIZE * 2, consts_3.consts.DEFAULT_GRID_SIZE * 2, consts_3.consts.DEFAULT_GRID_SIZE * 2, 1), new three_1.MeshBasicMaterial({
                color: 0xdddddd,
                side: three_1.DoubleSide,
                // opacity: 0.7,
                // transparent: true,
            }));
            this.backgroundPlane.position.set(0, 0, 0);
            this.backgroundPlane.visible = false;
            this.backgroundPlane.lookAt(this.camera.position);
            this.getScene().add(this.backgroundPlane);
            this.getScene().add(this.camera);
            this.rendererHelper = new classes_1.RendererHelper(canvasViewer, this.scene, this.camera);
            // init OrbitControls
            this.orbitControls = new classes_1.OrbitControlsHelper(this.camera, this.rendererHelper.domElement);
            this.orbitControls.enablePan = false;
            this.slidePlane = new three_1.Mesh(new three_1.PlaneGeometry(consts_3.consts.DEFAULT_GRID_SIZE * 5, consts_3.consts.DEFAULT_GRID_SIZE * 5, consts_3.consts.DEFAULT_GRID_SIZE * 5, 1), new three_1.MeshBasicMaterial({
                color: 0xdddddd,
                side: three_1.DoubleSide,
            }));
            this.slidePlane.position.set(0, 0, 0);
            this.slidePlane.visible = false;
            this.slidePlane.name = 'slidePlane';
            this.getScene().add(this.slidePlane);
            // eslint-disable-next-line react/no-unused-class-component-methods
            this.slidePlaneInitialRotation = new three_1.Euler().copy(this.slidePlane.rotation);
            const arcGeometry = new three_1.CircleGeometry(4, 32);
            const arcMaterial = new three_1.MeshBasicMaterial({
                color: 0x0662ac,
                opacity: 0.5,
                transparent: true,
            });
            arcMaterial.side = three_1.DoubleSide;
            this.angleArc = new three_1.Mesh(arcGeometry, arcMaterial);
            this.angleArc.visible = false;
            this.getScene().add(this.angleArc);
            // init GridControls
            this.gridControlsHelper = new classes_1.GridControlsHelper(this, consts_3.consts.DEFAULT_GRID_SIZE);
            this.scene.add(this.gridControlsHelper);
            this.recalculateGridScale();
            // init Lights
            const lightsHelper = new classes_1.LightsHelper();
            lightsHelper.lights.forEach((light) => {
                this.getScene().add(light);
            });
            // init axes
            // const axes = new AxesHelper(5);
            // this.getScene().add(axes);
            // init collision processor and helper
            // eslint-disable-next-line react/no-unused-class-component-methods
            this.collisionProcessor = new classes_1.CollisionProcessor(this);
            this.anchorDetection = new AnchorDetection_3d_1.default();
            this.hoverHelper = new classes_1.HoverHelper(this);
            // init main tool
            this.designProMain = new classes_1.DesignProMain(this);
            this.windowSelectionTool = new classes_1.WindowSelectionHelper(this);
            this.pointToPointMeasureTool = new PointToPointMeasureTool_3d_1.default(this);
            this.balloonsManager = new BomBalloonsManagerV2_1.default(this);
            this.screenShotManager = new ScreenShotManager_1.ScreenShotManager(this);
            // init Events
            this.boundOnResize = this.onResize.bind(this);
            this.boundHandleViewerKeyDown = this.handleViewerKeyDown.bind(this);
            this.boundOnRequestScreenshots = this.onRequestScreenshots.bind(this);
            this.boundOnFastenersExistence = this.onInformationAboutBuiltInFastenersGot.bind(this);
            window.addEventListener('resize', this.boundOnResize, false);
            if (process.env.NODE_ENV === 'development') {
                this.fpsCounter = new FpsCounter_1.default((fps) => {
                    const fpsDOMElement = document.getElementById(consts_3.consts.FPS_COUNTER_ID);
                    // eslint-disable-next-line no-unused-expressions
                    fpsDOMElement && (fpsDOMElement.innerText = `${Math.round(fps)}`);
                }, 10);
                this.logger = new Logger_1.default(1);
                const onAnimationFrame = () => {
                    var _a, _b;
                    (_a = this.fpsCounter) === null || _a === void 0 ? void 0 : _a.tick();
                    (_b = this.logger) === null || _b === void 0 ? void 0 : _b.tick();
                    requestAnimationFrame(onAnimationFrame);
                };
                requestAnimationFrame(onAnimationFrame);
                this.boundDevKeyDown = (e) => {
                    var _a;
                    switch (e.code) {
                        case 'KeyP': // P
                        case 'BracketRight': // ]
                            (_a = this.logger) === null || _a === void 0 ? void 0 : _a.showStats();
                            break;
                        case 'Tab': // Tab
                            this.drawBalloons(this.camera);
                            break;
                        case 'KeyI': // I
                            this.clearBalloons();
                            break;
                        default:
                            break;
                    }
                };
                document.addEventListener('keydown', this.boundDevKeyDown);
                (0, ViewerTestBridge_1.setupViewerTestBridge)(this);
            }
            document.body.addEventListener(events_2.requestScreenshots, this.boundOnRequestScreenshots);
            document.addEventListener('keydown', this.boundHandleViewerKeyDown, false);
            document.body.addEventListener(events_2.requestFastenersExistence, this.boundOnFastenersExistence);
            // Mouse wheel Events on canvas
            (_a = document.getElementById(consts_3.consts.CANVAS_ID)) === null || _a === void 0 ? void 0 : _a.addEventListener('wheel', (event) => {
                if (event.ctrlKey) {
                    // Prevent zoom of webpage if you on canvas+ctrl+downWheel+WheelRotate
                    event.preventDefault();
                    return false;
                }
                return true;
            }, { passive: false });
            this.getRendererDOMElement().oncontextmenu = (e) => {
                e.preventDefault();
                return false;
            };
            this.getRendererDOMElement().addEventListener('mousemove', this.onMouseMove.bind(this), false);
            this.getRendererDOMElement().addEventListener('mousedown', this.onMouseDown.bind(this), false);
            this.boundOnMouseUp = this.onMouseUp.bind(this);
            this.getRendererDOMElement().addEventListener('mouseup', this.boundOnMouseUp, false);
            this.updateViewCube();
            this.orbitControls.addEventListener('change', (p) => {
                const { selectedTool } = this.props;
                // Is Used for position the backgroundPlane in front of camera always
                this.backgroundPlane.rotation.setFromRotationMatrix(this.camera.matrix);
                this.updateViewCube();
                // disabling scene rerender when using custom rotation over the rotation center only
                if (selectedTool === consts_1.TOOL_STATE.ROTATE_SCENE && this.rotationCenterFound === true) {
                    return;
                }
                if (selectedTool === consts_1.TOOL_STATE.MEASURE) {
                    this.pointToPointMeasureTool.update();
                }
                this.designProMain.updateLabelsPositions();
                this.recalculateGridScale();
            });
            // add intersection point visualization for testing
            // params and color will be moved to consts later when this point will be used as the rotation centre visualization
            const tinySphere = new three_1.SphereGeometry(0.1, 32, 16);
            const material = new three_1.MeshBasicMaterial({ color: 0xffff00 });
            this.intersectionPoint = new three_1.Mesh(tinySphere, material);
            this.intersectionPoint.position.set(2000, 2000, 2000);
            this.intersectionPoint.visible = false;
            this.getScene().add(this.intersectionPoint);
            this.shouldAnimate = true;
            this.animate();
            this.setIsImperialMeasurementUnits(true);
        };
        // eslint-disable-next-line react/no-unused-class-component-methods
        this.enableViewCubeEvents = () => {
            this.getViewCubeElement().style.pointerEvents = 'all';
        };
        // eslint-disable-next-line react/no-unused-class-component-methods
        this.disableViewCubeEvents = () => {
            this.getViewCubeElement().style.pointerEvents = 'none';
        };
        this.updateViewCube = () => {
            const cube = this.getViewCubeElement();
            if (cube && this.camera) {
                const translateZ = -Number.parseInt(getComputedStyle(cube).width, 10) / 2;
                cube.style.transform = `translateZ(${translateZ}px) ${this.getCameraCSSMatrix(this.camera.matrixWorldInverse)}`;
            }
        };
        this.zoomToFit = (optBox) => {
            if (!optBox) {
                return;
            }
            const boundingSphere = optBox.getBoundingSphere(new three_1.Sphere());
            const distanceToTarget = this.effectiveDistanceToSphere(boundingSphere);
            const initialCameraPosition = this.getCamera().position.clone();
            const initialTarget = this.getControls().target.clone();
            const cameraDirection = new three_1.Vector3();
            this.getCamera().getWorldDirection(cameraDirection);
            const newCameraPosition = cameraDirection.negate().setLength(distanceToTarget).add(boundingSphere.center);
            const cameraMovement = new three_1.Vector3().subVectors(newCameraPosition, initialCameraPosition);
            const targetMovement = new three_1.Vector3().subVectors(boundingSphere.center, initialTarget);
            const temp1 = new three_1.Vector3();
            const temp2 = new three_1.Vector3();
            (0, utils_1.animate)({
                timing: (t) => t,
                duration: 300,
                draw: (t) => {
                    this.camera.position.copy(temp1.addVectors(initialCameraPosition, temp2.lerp(cameraMovement, t)));
                    this.getControls().target.copy(temp1.addVectors(initialTarget, temp2.lerp(targetMovement, t)));
                    this.rendererHelper.render(this.scene, this.camera);
                },
            });
        };
        // eslint-disable-next-line react/no-unused-class-component-methods
        this.zoomIn = () => {
            this.orbitControls.zoomToPointWithControls(this.orbitControls.target, consts_3.consts.ZOOM_FOR_ZOOM_BUTTONS);
            this.recalculateGridScale();
        };
        // eslint-disable-next-line react/no-unused-class-component-methods
        this.zoomOut = () => {
            this.orbitControls.zoomToPointWithControls(this.orbitControls.target, -consts_3.consts.ZOOM_FOR_ZOOM_BUTTONS);
            this.recalculateGridScale();
        };
        /**
         * This function tweens camera for the current position to the new position
         * Note: even though it does smooth camera movement and rotation,
         *       the actual movement trajectory in 3d space is linear.
         * @param position - final camera position
         * @param up       - final camera up position
         * @param target   - target you look at
         * @param easing   - function to make the animation smooth. See https://sole.github.io/tween.js/examples/03_graphs.html
         */
        this.tweenCamera = (position, up, target, easing = tween_js_1.Easing.Sinusoidal.InOut) => {
            this.getControls().disable();
            new tween_js_1.Tween(this.camera.position)
                .to(position)
                .easing(easing)
                .onStart(() => {
                new tween_js_1.Tween(this.camera.up)
                    .to(up)
                    .easing(easing)
                    .onStart(() => {
                    new tween_js_1.Tween(this.getControls().target).to(target).easing(easing).start();
                })
                    .start();
            })
                .start();
            (0, utils_1.animate)({
                timing: (t) => t,
                duration: 1000,
                draw: (t) => {
                    tween_js_1.default.update();
                    this.updateViewCube();
                },
            });
            this.getControls().enable();
        };
        // eslint-disable-next-line react/no-unused-class-component-methods
        this.toggleViewCube = (cameraView) => {
            const boundingSphere = ((optBox) => {
                if (optBox) {
                    return optBox.getBoundingSphere(new three_1.Sphere());
                }
                return new three_1.Sphere(new three_1.Vector3(0, 0, -20), 30);
            })(this.maybeAllPartsBoundingBox());
            cameraView.offset.multiplyScalar(this.camera.position.length());
            const targetPosition = new three_1.Vector3().copy(this.camera
                .getWorldDirection(new three_1.Vector3())
                .negate()
                .copy(cameraView.offset)
                .setLength(this.effectiveDistanceToSphere(boundingSphere))
                .add(boundingSphere.center));
            this.tweenCamera(targetPosition, cameraView.up, boundingSphere.center, tween_js_1.Easing.Sinusoidal.InOut);
        };
        this.handleEscape = () => {
            const { unselectCatalogItems, setLoadingModel } = this.props;
            this.designProMain.removeTransformControlsFromScene();
            this.designProMain.transformationInProgress = false;
            this.designProMain.terminatePartInserting();
            unselectCatalogItems();
            this.angleArc.visible = false;
            this.designProMain.selectionTool.unselectAll();
            setLoadingModel(false);
            this.updateBuildPlanePosition();
            this.designProMain.capHelper.removeCones();
        };
        this.getDesignProMain = () => {
            return this.designProMain;
        };
        this.animate = () => {
            if (this.shouldAnimate) {
                this.requestAnimationFrameId = requestAnimationFrame(this.animate.bind(this));
                this.orbitControls.update();
                this.renderScene(this.scene, this.camera);
            }
        };
        // eslint-disable-next-line react/no-unused-class-component-methods
        this.triggerSceneRender = () => {
            this.renderScene(this.scene, this.camera);
        };
        // eslint-disable-next-line react/no-unused-class-component-methods
        this.setFastenersDefaultStyle = () => {
            this.getAllConnections().forEach((connectionObject) => {
                connectionObject.unselectFasteners();
                connectionObject.unselectSphere();
                connectionObject.showSelectionBox();
            });
        };
        // eslint-disable-next-line react/no-unused-class-component-methods
        this.getNumberOfFasteners = () => {
            return this.getScene().children.reduce((fastenerCount, child) => {
                return utils_2.Utils.isConnection(child) ? fastenerCount + child.getFastenerCount() : fastenerCount;
            }, 0);
        };
        this.getFasteners = () => {
            return this.getScene().children.reduce((fasteners, child) => {
                if (utils_2.Utils.isConnection(child)) {
                    fasteners.push(...child.getFasteners());
                }
                return fasteners;
            }, []);
        };
        this.isObjectUnderInsertion = (obj) => {
            const designProMain = this.getDesignProMain();
            if (!designProMain) {
                return false;
            }
            const { copyingObjects, scalingTool, snappingTool } = designProMain;
            return (scalingTool.getObject() === obj ||
                snappingTool.getObject() === obj ||
                copyingObjects.some((objectUnderCopy) => objectUnderCopy === obj));
        };
        this.getPanels = () => {
            return this.getScene()
                .children.filter(utils_2.Utils.isPanel)
                .filter((panel) => !this.isObjectUnderInsertion(panel));
        };
        this.getExtrusionProfiles = () => {
            return this.getScene()
                .children.filter(utils_2.Utils.isExtrusion)
                .filter((extrusion) => !this.isObjectUnderInsertion(extrusion));
        };
        this.getComponents = () => {
            return this.getScene()
                .children.filter(utils_2.Utils.isComponent)
                .filter((component) => !this.isObjectUnderInsertion(component));
        };
        this.onRequestScreenshots = (event) => __awaiter(this, void 0, void 0, function* () {
            const explosionCoefficient = event.detail;
            // TODO: Take all screen shots using ScreenShotManager instance of this
            const blobs = yield (0, screenshots_1.default)(this, undefined, {
                isometric: true,
                front: true,
                isometricWithBalloons: true,
                explodedWithBalloonsForExtrusions: true,
                explodedWithBalloonsForComponents: true,
                panels: true,
                projectDimensions: true,
            }, explosionCoefficient);
            document.body.dispatchEvent((0, events_1.responseScreenshotsEvent)(blobs));
        });
        // eslint-disable-next-line react/no-unused-class-component-methods
        this.getSizeByUUID = (uuid, isImperial = true) => {
            if (!uuid) {
                return null;
            }
            const object = utils_2.Utils.getObjectByUUID(this.scene, uuid);
            if (!object.partDetails.isScalable) {
                return null;
            }
            const imperialSize = object.type === 'Panel'
                ? {
                    x: object.getWidth(),
                    y: object.getHeight(),
                }
                : {
                    z: object.getLength(),
                };
            const size = {};
            // eslint-disable-next-line no-restricted-syntax
            for (const axis in imperialSize) {
                if (Object.prototype.hasOwnProperty.call(imperialSize, axis)) {
                    size[axis] = (0, utils_3d_1.roundTo3)(isImperial ? imperialSize[axis] : imperialSize[axis] * consts_3.consts.INCH_TO_MM);
                }
            }
            return size;
        };
        // eslint-disable-next-line react/no-unused-class-component-methods, class-methods-use-this
        this.pressEnter = (uuid) => {
            if (!uuid) {
                return;
            }
            if (!this.designProMain.transformationInProgress) {
                this.designProMain.finalizeObjectInsertionOnMouseDown();
            }
            else {
                const object = this.designProMain.transformControlsInitial.object;
                object.unselect();
                this.designProMain.transformControlsInitial.detach();
                this.designProMain.refreshLabels();
                this.designProMain.selectionTool.unselectAll();
                this.props.setToolToDefault();
            }
        };
        // eslint-disable-next-line react/no-unused-class-component-methods
        this.changeItemSize = (uuid, size, isImperial = true) => {
            if (!uuid) {
                return;
            }
            const object = utils_2.Utils.getObjectByUUID(this.scene, uuid);
            const oldSize = object.getSize();
            const newSize = oldSize.clone();
            if (consts_2.Axis.x in size && size.x !== undefined) {
                newSize.x = isImperial ? size.x : size.x * consts_3.consts.MM_TO_INCH;
            }
            if (consts_2.Axis.y in size && size.y !== undefined) {
                newSize.y = isImperial ? size.y : size.y * consts_3.consts.MM_TO_INCH;
            }
            if (consts_2.Axis.z in size && size.z !== undefined) {
                newSize.z = isImperial ? size.z : size.z * consts_3.consts.MM_TO_INCH;
            }
            if (utils_2.Utils.areVectorsEqual(oldSize, newSize)) {
                return;
            }
            object.positionOnDown = object.position.clone();
            object.quaternionOnDown = object.quaternion.clone();
            object.scaleOnDown = object.getScale().clone();
            object.setSize(newSize);
            this.getDesignProMain().historyService.execute(new commands_1.SetScaleCommand(object, this, this.getDesignProMain().historyService));
            this.designProMain.resetLastScaledObject();
        };
        this.changeItemPosition = (uuid, position) => {
            if (!uuid) {
                return;
            }
            const object = utils_2.Utils.getObjectByUUID(this.scene, uuid);
            if (!object) {
                return;
            }
            object.positionOnDown = object.position.clone();
            object.setPosition(new three_1.Vector3(position.x, position.y, position.z));
            this.getDesignProMain().historyService.execute(new commands_1.SetPositionCommand([object], this, this.getDesignProMain().historyService));
        };
        this.state = {};
        this.shouldAnimate = false;
        // eslint-disable-next-line no-underscore-dangle
        Viewer._instance = this;
        this.init = this.init.bind(this);
    }
    componentDidMount() {
        this.init();
        const { selectedTool } = this.props;
        this.orbitControls.mouseButtons = utils_2.Utils.setOrbitControls(selectedTool).mouseButtons;
        this.updateCursorForTool();
    }
    // React function calls when the state changes.
    componentDidUpdate(prevProps) {
        const { selectedTool, selectedTransformMode, drawingAngled } = this.props;
        if (prevProps.drawingAngled !== drawingAngled) {
            if (this.designProMain.drawingAngledLock) {
                this.designProMain.escapeClear();
            }
        }
        if (prevProps.selectedTool !== selectedTool) {
            if (prevProps.selectedTool === consts_1.TOOL_STATE.SHOW_FASTENERS) {
                this.designProMain.deactivateFasteners();
            }
            else if (selectedTool === consts_1.TOOL_STATE.SHOW_FASTENERS) {
                this.makeScreenshotImmediately().then(() => {
                    this.designProMain.activateFasteners();
                });
            }
            if (prevProps.selectedTool === consts_1.TOOL_STATE.MEASURE) {
                this.pointToPointMeasureTool.clear();
            }
            this.resetOrbitControlsToolState(selectedTool); // Only add this line
            this.updateCursorForTool();
            if (selectedTool !== consts_1.TOOL_STATE.DRAW) {
                this.handleEscape();
            }
            this.orbitControls.mouseButtons = utils_2.Utils.setOrbitControls(selectedTool).mouseButtons;
            if (selectedTool === consts_1.TOOL_STATE.NAVIGATE) {
                this.designProMain.selectionTool.unselectAll();
                this.designProMain.removeTransformControlsFromScene();
                this.designProMain.transformationInProgress = false;
            }
        }
        if (prevProps.selectedTransformMode !== selectedTransformMode) {
            this.designProMain.dimensioningTool.dispose();
            const selected = this.selectedObjects.length >= 1 && this.selectedObjects;
            if (!selected) {
                return;
            }
            let isScalable = false;
            let isRotatable = false;
            let isMovable = false;
            if (selectedTool !== consts_1.TOOL_STATE.MEASURE) {
                [isScalable, isRotatable, isMovable] = this.designProMain.selectionTool.getIsScalableRotatableMovableParams();
            }
            let shouldAttach = false;
            const { isProjectArchived, isOrderCompleted, isProjectViewOnly } = this.props;
            switch (selectedTransformMode) {
                case consts_1.TRANSFORM_MODE.TRANSLATE:
                    if (!isMovable || isProjectArchived || isOrderCompleted || isProjectViewOnly) {
                        break;
                    }
                    this.designProMain.transformControlsInitial.setMode(consts_1.TRANSFORM_MODE.TRANSLATE);
                    this.designProMain.transformControlsInitial.showX = true;
                    this.designProMain.transformControlsInitial.showY = true;
                    this.designProMain.transformControlsInitial.showZ = true;
                    shouldAttach = true;
                    break;
                case consts_1.TRANSFORM_MODE.ROTATE:
                    if (!isRotatable) {
                        break;
                    }
                    this.designProMain.transformControlsInitial.setMode(consts_1.TRANSFORM_MODE.ROTATE);
                    this.designProMain.transformControlsInitial.showX = true;
                    this.designProMain.transformControlsInitial.showY = true;
                    this.designProMain.transformControlsInitial.showZ = true;
                    shouldAttach = true;
                    break;
                case consts_1.TRANSFORM_MODE.SCALE:
                    if (isScalable) {
                        this.designProMain.transformControlsInitial.setMode(consts_1.TRANSFORM_MODE.SCALE);
                        if (selected.length === 1 && selected[0].type === 'Panel') {
                            this.designProMain.transformControlsInitial.showZ = false;
                            this.designProMain.transformControlsInitial.showX = true;
                            this.designProMain.transformControlsInitial.showY = true;
                            this.designProMain.dimensioningTool.definePanelDimensions(selected[0]);
                        }
                        else {
                            this.designProMain.transformControlsInitial.showZ = true;
                            this.designProMain.transformControlsInitial.showX = false;
                            this.designProMain.transformControlsInitial.showY = false;
                        }
                        shouldAttach = true;
                    }
                    break;
                case consts_1.TRANSFORM_MODE.NONE:
                    this.designProMain.transformControlsInitial.setMode(consts_1.TRANSFORM_MODE.NONE);
                    break;
                default:
                    break;
            }
            if (this.selectedObjects.length >= 1) {
                this.designProMain.transformControlsInitial.detach();
                this.designProMain.transformationInProgress = false;
                if (shouldAttach && this.masterPart) {
                    this.designProMain.transformationInProgress = true;
                    this.designProMain.transformControlsInitial.attach(this.masterPart);
                    this.designProMain.transformControlsInitial.objectType = selected[0].type;
                    const shouldDisplayScalingValue = selectedTransformMode === consts_1.TRANSFORM_MODE.SCALE &&
                        selected.length === 1 &&
                        selected[0].type !== 'Panel';
                    if (shouldDisplayScalingValue) {
                        this.designProMain.scalingTool.displayScalingValue(this.masterPart);
                    }
                }
            }
        }
    }
    componentWillUnmount() {
        this.designProMain.dispose();
        this.designProMain.capHelper.removeEventListeners();
        this.clearScreenshotTimeout();
        window.removeEventListener('resize', this.boundOnResize, false);
        document.removeEventListener('keydown', this.boundHandleViewerKeyDown, false);
        document.body.removeEventListener(events_2.requestScreenshots, this.boundOnRequestScreenshots);
        document.body.removeEventListener(events_2.requestFastenersExistence, this.boundOnFastenersExistence);
        this.getRendererDOMElement().removeEventListener('mouseup', this.boundOnMouseUp, false);
        if (this.boundDevKeyDown) {
            document.removeEventListener('keydown', this.boundDevKeyDown);
        }
    }
    // reset OrbitControls ToolState to initial state
    // eslint-disable-next-line react/sort-comp
    resetOrbitControlsToolState(selectedTool) {
        if (selectedTool === consts_1.TOOL_STATE.DRAW ||
            selectedTool === consts_1.TOOL_STATE.NAVIGATE ||
            selectedTool === consts_1.TOOL_STATE.ROTATE_SCENE ||
            selectedTool === consts_1.TOOL_STATE.SHOW_FASTENERS) {
            this.orbitControls.enablePan = false;
        }
        if (selectedTool === consts_1.TOOL_STATE.PAN) {
            this.orbitControls.enablePan = true;
        }
        // Are true in all STATES
        this.orbitControls.enableRotate = true;
        this.orbitControls.enableZoom = true;
    }
    updateCursorForTool() {
        let cursor = 'auto';
        if (this.props.selectedTool === consts_1.TOOL_STATE.PAN) {
            cursor = panCursor;
        }
        else if (this.props.selectedTool === consts_1.TOOL_STATE.ROTATE_SCENE) {
            cursor = rotateCursor;
        }
        this.getRendererDOMElement().style.cursor = cursor;
    }
    // eslint-disable-next-line class-methods-use-this
    getCameraCSSMatrix(matrix) {
        const { elements } = matrix;
        const epsilon = (value) => {
            return Math.abs(value) < 1e-10 ? 0 : value;
        };
        return `matrix3d(
          ${epsilon(elements[0])}, ${epsilon(-elements[1])}, ${epsilon(elements[2])}, 0,
          ${epsilon(elements[4])}, ${epsilon(-elements[5])}, ${epsilon(elements[6])}, 0,
          ${epsilon(elements[8])}, ${epsilon(-elements[9])}, ${epsilon(elements[10])}, 0,
          0, 0, 0, 1)`;
    }
    // eslint-disable-next-line react/no-unused-class-component-methods
    maybeZoomToFitSelectedObjects() {
        const box = new three_1.Box3(new three_1.Vector3(), new three_1.Vector3());
        if (!this.selectedObjects.length) {
            return;
        }
        this.selectedObjects.forEach((obj) => {
            box.union(utils_2.Utils.getAABBox(obj));
        });
        if (!box.isEmpty()) {
            this.zoomToFit(box);
        }
    }
    effectiveDistanceToSphere(boundingSphere) {
        const ADDITIONAL_SIZE_COEF = 1.2;
        return ((boundingSphere.radius * ADDITIONAL_SIZE_COEF) / Math.tan(((this.camera.getEffectiveFOV() / 2) * Math.PI) / 180));
    }
    /*
     * Handle Keyboard events and action
     */
    handleViewerKeyDown(event) {
        switch (event.key) {
            case 'Escape':
                if ((this.designProMain.transformationInProgress && this.mouseDown) || this.props.modals.length > 0) {
                    return;
                }
                // eslint-disable-next-line react/destructuring-assignment
                this.props.setToolToDefault();
                this.handleEscape();
                break;
            case 'Control':
                if (!this.orbitControls.enablePan) {
                    this.orbitControls.enablePan = true;
                }
                break;
            default:
                break;
        }
    }
    // eslint-disable-next-line class-methods-use-this
    getViewCubeElement() {
        return document.getElementById(consts_3.consts.VIEWCUBE_ID);
    }
    // eslint-disable-next-line class-methods-use-this
    getRendererDOMElement() {
        return document.getElementById(consts_3.consts.CANVAS_ID);
    }
    getCamera() {
        return this.camera;
    }
    getControls() {
        return this.orbitControls;
    }
    getScene() {
        return this.scene;
    }
    // eslint-disable-next-line react/no-unused-class-component-methods
    getRenderer() {
        return this.rendererHelper;
    }
    getGrid() {
        return this.gridControlsHelper;
    }
    getRaycaster() {
        return this.raycaster;
    }
    getMouse() {
        return this.mouse;
    }
    getBackgroundPlane() {
        return this.backgroundPlane;
    }
    // eslint-disable-next-line react/no-unused-class-component-methods
    getObjectById(uuid) {
        var _a;
        return (_a = this.scene) === null || _a === void 0 ? void 0 : _a.getObjectByProperty('uuid', uuid);
    }
    getAllConnections() {
        return this.getScene().children.filter((child) => utils_2.Utils.isConnection(child));
    }
    renderScene(scene, camera) {
        this.rendererHelper.render(scene, camera);
    }
    updateViewer() {
        this.camera.updateProjectionMatrix();
        this.orbitControls.update();
    }
    // eslint-disable-next-line react/no-unused-class-component-methods
    calcHover(excludeIDs = new Set()) {
        let anchorTestResult;
        const hoverTestResult = this.hoverHelper.testHoveredObjects(excludeIDs);
        if (hoverTestResult.object === null) {
            anchorTestResult = {
                resultType: AnchorDetection_3d_1.AnchorResultType.buildPlane,
                intersectionPoint: hoverTestResult.point,
                intersectionNormal: hoverTestResult.normal,
                resultData: null,
                objectUUID: null,
            };
        }
        else {
            anchorTestResult = this.anchorDetection.testByPoint(hoverTestResult.object, hoverTestResult.point, hoverTestResult.normal);
        }
        return anchorTestResult;
    }
    getObjectIntersections(event) {
        const intersections = {
            customObject: null,
            backgroundPlane: null,
            outerBox: null,
            fastener: null,
            anywhere: null,
            buildPlane: null,
            customObjectExcludePreview: null,
        };
        const rect = this.getRendererDOMElement().getBoundingClientRect();
        this.getMouse().x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
        this.getMouse().y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
        this.getRaycaster().setFromCamera(this.getMouse(), this.getCamera());
        this.getScene().children.forEach((child) => {
            var _a, _b, _c, _d, _e, _f;
            const object = child;
            if (object.isCustomObject) {
                const [objectIntersection] = this.getRaycaster().intersectObject(object.mesh, true);
                if (objectIntersection &&
                    object.uuid !== ((_a = this.designProMain.scalingTool.getObject()) === null || _a === void 0 ? void 0 : _a.uuid) &&
                    objectIntersection.distance < ((_c = (_b = intersections.customObjectExcludePreview) === null || _b === void 0 ? void 0 : _b.distance) !== null && _c !== void 0 ? _c : Infinity)) {
                    intersections.customObjectExcludePreview = objectIntersection;
                }
                if (objectIntersection &&
                    (!intersections.customObject || objectIntersection.distance < intersections.customObject.distance)) {
                    intersections.customObject = objectIntersection;
                }
                // Get intersections with object's outer box (excluding the outer box of preview)
                if (object.uuid !== ((_d = this.designProMain.snappingTool.getObject()) === null || _d === void 0 ? void 0 : _d.uuid)) {
                    const [outerBoxIntersection] = this.getRaycaster().intersectObject(object.outerBox, true);
                    if (outerBoxIntersection &&
                        (!intersections.outerBox || outerBoxIntersection.distance < intersections.outerBox.distance)) {
                        intersections.outerBox = outerBoxIntersection;
                        if ((_f = (_e = intersections.outerBox) === null || _e === void 0 ? void 0 : _e.face) === null || _f === void 0 ? void 0 : _f.normal) {
                            // This made to make normal in WCS instead of LCS
                            intersections.outerBox.face.normal = utils_2.Utils.roundVectorTo3(intersections.outerBox.face.normal.applyQuaternion(object.quaternion));
                        }
                    }
                }
            }
            else if (object.type === 'Connection') {
                const [fastenerIntersection] = this.getRaycaster().intersectObject(object, true);
                if (fastenerIntersection) {
                    if ((intersections.fastener && intersections.fastener.distance > fastenerIntersection.distance) ||
                        !intersections.fastener) {
                        intersections.fastener = fastenerIntersection;
                    }
                }
            }
            else if (object.uuid === this.gridControlsHelper.uuid) {
                const [buildPlaneIntersection] = this.getRaycaster().intersectObject(object, true);
                if (buildPlaneIntersection) {
                    intersections.buildPlane = buildPlaneIntersection;
                }
            }
            else {
                const [otherIntersection] = this.getRaycaster().intersectObject(object, true);
                if (otherIntersection) {
                    intersections.anywhere = otherIntersection;
                }
            }
        });
        const [planeIntersection] = this.getRaycaster().intersectObject(this.getBackgroundPlane(), true);
        if (planeIntersection) {
            intersections.backgroundPlane = planeIntersection;
        }
        return intersections;
    }
    getZoomPointOutsideOfMesh(event) {
        const outOfMeshPoint = new three_1.Vector3();
        this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
        this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
        outOfMeshPoint.set(this.mouse.x, this.mouse.y, (this.camera.near + this.camera.far) / (this.camera.near - this.camera.far));
        outOfMeshPoint.unproject(this.camera);
        return outOfMeshPoint;
    }
    drawIntersectionPoint(closestIntersectionPoint) {
        this.intersectionPoint.position.set(closestIntersectionPoint.x, closestIntersectionPoint.y, closestIntersectionPoint.z);
        this.intersectionPoint.visible = true;
    }
    hideIntersectionPoint() {
        this.intersectionPoint.visible = false;
    }
    onResize(event) {
        this.rendererHelper.setSize(window.innerWidth, window.innerHeight);
        this.camera.aspect = window.innerWidth / window.innerHeight;
        // update the scene
        this.updateViewer();
    }
    onMouseMove(event) {
        var _a, _b;
        const { selectedTool } = this.props;
        if (selectedTool === consts_1.TOOL_STATE.MEASURE && !this.mouseDown) {
            this.pointToPointMeasureTool.handleMouseMove();
        }
        if (this.props.selectedTool === consts_1.TOOL_STATE.SHOW_FASTENERS) {
            const allConnections = this.getAllConnections();
            const { fastener: fastenerIntersection } = this.getObjectIntersections(event);
            allConnections.forEach((currentConnection) => this.fastenerHoverHelper.onHover(fastenerIntersection, currentConnection, allConnections));
        }
        if (this.windowSelectionTool.isMouseDown) {
            this.windowSelectionTool.updateSelection(event);
            return;
        }
        if (event.buttons === 2) {
            return;
        }
        if (event.buttons !== 4 || (!event.ctrlKey && !event.altKey)) {
            this.transformControlsUsed = this.designProMain.transformControlsInitial.dragging;
            let intersectionWithMesh = [];
            const outOfMeshPoint = this.getZoomPointOutsideOfMesh(event); // a point to zoom outside of any mesh children
            this.objectsIntersections = this.getObjectIntersections(event);
            const hoveredObject = 
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-non-null-asserted-optional-chain
            ((_a = this.objectsIntersections.customObject) === null || _a === void 0 ? void 0 : _a.object) || ((_b = this.objectsIntersections.backgroundPlane) === null || _b === void 0 ? void 0 : _b.object);
            if (hoveredObject) {
                intersectionWithMesh = this.detectIntersection(event, hoveredObject, true);
            }
            this.getControls().zoomToPointFlag = true;
            if (intersectionWithMesh.length > 0) {
                this.getControls().zoomPoint.copy(intersectionWithMesh[0].point);
            }
            else {
                this.getControls().zoomPoint.copy(outOfMeshPoint);
            }
        }
        if (this.rotationCenterFound &&
            this.mouseDown
        // this.props.selectedTool === TOOL_STATE.ROTATE_SCENE // "Rotate scene" for now, will be changed later to "Rotate"
        ) {
            this.getRendererDOMElement().style.cursor = rotateCursor;
            // get new mouse position
            this.rotateEnd.set(event.clientX, event.clientY);
            this.rotateDelta.subVectors(this.rotateEnd, this.rotateStart);
            // get mouse move vector
            const moveInMouseDirVec = new three_1.Vector3(0, 0, 0);
            moveInMouseDirVec.set(this.rotateDelta.x * -1, this.rotateDelta.y, 0);
            const angle = moveInMouseDirVec.length();
            const angleWithRotationSpeed = angle /
                (consts_3.consts.ROTATION_ANGLE_ADJUSTMENT_COEFFICIENT /
                    // consts.CAMERA_OVER_POINT_ROTATION_SPEED); // will be back after testing is completed
                    // eslint-disable-next-line react/destructuring-assignment
                    this.props.rotationSpeed);
            const lookAtPoint = this.getControls().target;
            // move eye and target to origin
            const moveToFromOriginVec = new three_1.Vector3();
            moveToFromOriginVec.copy(this.rotationCenter).negate();
            this.getCamera().position.add(moveToFromOriginVec);
            lookAtPoint.add(moveToFromOriginVec);
            // rotate
            // 1. find the rotation axis
            const rotationAxis = new three_1.Vector3();
            const mouseStart3D = new three_1.Vector3();
            mouseStart3D.set(this.rotateStart.x * -1, this.rotateStart.y, 0).unproject(this.getCamera());
            const mouseEnd3D = new three_1.Vector3();
            mouseEnd3D.set(this.rotateEnd.x * -1, this.rotateEnd.y, 0).unproject(this.getCamera());
            moveInMouseDirVec.subVectors(mouseEnd3D, mouseStart3D).normalize();
            const toEyeVec = new three_1.Vector3();
            toEyeVec.copy(this.getCamera().position).normalize();
            rotationAxis.crossVectors(toEyeVec, moveInMouseDirVec);
            rotationAxis.normalize();
            // 2. rotate
            // this.hideIntersectionPoint();
            // this.gridControlsHelper.visible = false;
            const quaternion = new three_1.Quaternion();
            quaternion.setFromAxisAngle(rotationAxis, angleWithRotationSpeed);
            this.getCamera().position.applyQuaternion(quaternion);
            this.getCamera().up.applyQuaternion(quaternion);
            lookAtPoint.applyQuaternion(quaternion);
            this.drawIntersectionPoint(this.rotationCenter);
            // move back to initial position
            moveToFromOriginVec.negate();
            this.getCamera().position.add(moveToFromOriginVec);
            lookAtPoint.add(moveToFromOriginVec);
            this.getCamera().lookAt(lookAtPoint);
            // update the scene
            // this.updateViewer();
            this.rotateStart.copy(this.rotateEnd);
        }
    }
    onMouseDown(event) {
        var _a, _b;
        const { selectedTool } = this.props;
        if (event.button === consts_3.consts.BUTTONS.LEFT || event.button === consts_3.consts.BUTTONS.MIDDLE) {
            this.mouseDown = true;
        }
        event.preventDefault();
        if (event.button === consts_3.consts.BUTTONS.LEFT && selectedTool === consts_1.TOOL_STATE.NAVIGATE) {
            if ((this.getControls().enabled || !this.designProMain.transformationInProgress) &&
                !this.props.isDefaultFastenersWidgetShown &&
                !this.props.isItemReplacementWidgetShown) {
                this.windowSelectionTool.setStartPoint(event.clientX, event.clientY);
            }
            return;
        }
        if (event.button === consts_3.consts.BUTTONS.LEFT && selectedTool === consts_1.TOOL_STATE.MEASURE) {
            return;
        }
        if ((event.button === consts_3.consts.BUTTONS.MIDDLE && event.ctrlKey) ||
            (event.button === consts_3.consts.BUTTONS.LEFT && selectedTool === consts_1.TOOL_STATE.PAN)) {
            this.orbitControls.enablePan = true;
            this.getRendererDOMElement().style.cursor = panCursor;
        }
        else {
            this.orbitControls.enablePan = false;
        }
        if (event.button === consts_3.consts.BUTTONS.RIGHT ||
            this.orbitControls.enablePan ||
            (event.button === consts_3.consts.BUTTONS.LEFT && selectedTool === consts_1.TOOL_STATE.DRAW)) {
            return;
        }
        if (selectedTool !== consts_1.TOOL_STATE.SHOW_FASTENERS) {
            this.getRendererDOMElement().style.cursor = rotateCursor;
        }
        const intersect = this.getObjectIntersections(event).customObjectExcludePreview;
        this.mouse.x = (event.clientX / this.getRendererDOMElement().clientHeight) * 2 - 1;
        this.mouse.y = -(event.clientY / this.getRendererDOMElement().clientWidth) * 2 + 1;
        this.rotateStart.x = event.clientX;
        this.rotateStart.y = event.clientY;
        this.raycaster.setFromCamera(this.mouse, this.getCamera());
        if (intersect) {
            this.rotationCenterFound = true;
            this.getControls().rotationPointFlag = true;
            this.rotationCenter = intersect.point;
        }
        else {
            this.rotationCenterFound = true;
            this.getControls().rotationPointFlag = true;
            const line = utils_2.Utils.getCameraToPointerLineFromEvent(event, this.camera);
            this.rotationCenter = new three_1.Vector3().addVectors(this.camera.position, line
                .delta(new three_1.Vector3())
                .setLength(this.camera.position.distanceTo((_b = (_a = this.maybeAllPartsBoundingBox()) === null || _a === void 0 ? void 0 : _a.getCenter(tempVector1)) !== null && _b !== void 0 ? _b : tempVector1.set(0, 0, 0))));
        }
    }
    onMouseUp(event) {
        event.preventDefault();
        if (this.mouseDown || this.orbitControls.enablePan) {
            this.updateCursorForTool();
        }
        if (this.windowSelectionTool.isMouseDown) {
            this.windowSelectionTool.isMouseDown = false;
            if (this.windowSelectionTool.isActive) {
                this.windowSelectionTool.stopSelection(event.clientX, event.clientY);
                return;
            }
        }
        this.angleArc.visible = false;
        this.mouseDown = false;
        const { selectedTool } = this.props;
        if (event.button === consts_3.consts.BUTTONS.LEFT && selectedTool === consts_1.TOOL_STATE.MEASURE) {
            this.pointToPointMeasureTool.handleMouseUp();
            return;
        }
        if (selectedTool === consts_1.TOOL_STATE.SHOW_FASTENERS && event.button === consts_3.consts.BUTTONS.LEFT) {
            this.selectFastener(event);
        }
        if (event.button === consts_3.consts.BUTTONS.RIGHT &&
            selectedTool === consts_1.TOOL_STATE.NAVIGATE &&
            !this.props.isItemReplacementWidgetShown) {
            this.callContextMenu(event);
            return;
        }
        if (selectedTool === consts_1.TOOL_STATE.NAVIGATE) {
            this.orbitControls.enableRotate = true;
            if (event.button === consts_3.consts.BUTTONS.MIDDLE) {
                this.orbitControls.enablePan = true;
            }
            else if (!this.transformControlsUsed &&
                event.button === consts_3.consts.BUTTONS.LEFT &&
                !this.props.isDefaultFastenersWidgetShown &&
                !this.props.isItemReplacementWidgetShown) {
                this.selectObjects(event);
            }
        }
        if (selectedTool === consts_1.TOOL_STATE.PAN && event.button !== consts_3.consts.BUTTONS.MIDDLE) {
            this.orbitControls.enablePan = true;
        }
        if (!this.rotationCenterFound) {
            return;
        }
        this.hideIntersectionPoint();
        this.rotationCenterFound = false;
        this.getControls().rotationPointFlag = false;
    }
    callContextMenu(event) {
        var _a;
        const hoveredObject = (_a = this.getObjectIntersections(event).customObject) === null || _a === void 0 ? void 0 : _a.object.parent;
        if (!hoveredObject) {
            return;
        }
        if (!this.selectedObjects.some((o) => o.uuid === hoveredObject.uuid)) {
            if (!event.ctrlKey) {
                this.designProMain.selectionTool.unselectAll();
            }
            this.designProMain.selectionTool.selectObjects([hoveredObject]);
        }
        // eslint-disable-next-line react/destructuring-assignment
        this.props.setContextMenu({
            show: true,
            x: event.clientX,
            y: event.clientY,
            scalable: hoveredObject.partDetails.isScalable,
            angled: !!hoveredObject.scalingAngle,
            isMultiSelectMode: this.selectedObjects.length > 1,
            selectedIds: this.designProMain.selectionTool.selectedObjectsUuids,
        });
    }
    selectFastener(event) {
        var _a, _b;
        const fastenerIntersection = this.getObjectIntersections(event).fastener;
        const { isOrderCompleted } = this.props;
        if (!fastenerIntersection) {
            return;
        }
        const selectedFastener = fastenerIntersection.object;
        const selectedFastenerParent = selectedFastener.parent;
        if (!selectedFastenerParent) {
            return;
        }
        let selectedConnection = null;
        if (utils_2.Utils.isConnection(selectedFastenerParent)) {
            selectedConnection = selectedFastenerParent;
        }
        else if (selectedFastenerParent.parent && utils_2.Utils.isConnection(selectedFastenerParent.parent)) {
            selectedConnection = selectedFastenerParent.parent;
        }
        let fastener = null;
        if (utils_2.Utils.isFastener(selectedFastener)) {
            fastener = selectedFastener;
        }
        else if (utils_2.Utils.isFastener(selectedFastenerParent)) {
            fastener = selectedFastenerParent;
        }
        if (!selectedConnection) {
            return;
        }
        if (fastener) {
            // Temporary fix
            // TODO move this login into FastenerPreviewHelper and Fastener.model
            if (fastener.fastenerState === 'empty model') {
                fastener.setVisualState('filled model');
                (_a = FastenerPreviewHelper_3d_1.default.onFastenersPreviewApplied) === null || _a === void 0 ? void 0 : _a.call(null, FastenerPreviewHelper_3d_1.default.connectionsData);
                return;
            }
            if (fastener.fastenerState === 'filled model') {
                fastener.setVisualState('empty model');
                (_b = FastenerPreviewHelper_3d_1.default.onFastenersPreviewApplied) === null || _b === void 0 ? void 0 : _b.call(null, FastenerPreviewHelper_3d_1.default.connectionsData);
                return;
            }
        }
        const allConnections = this.getAllConnections();
        allConnections.forEach((connectionObject) => {
            connectionObject.unselectFasteners();
            connectionObject.unselectSphere();
            connectionObject.showSelectionBox();
        });
        selectedConnection.selectFasteners();
        selectedConnection.selectSphere();
        selectedConnection.showSelectionBox(consts_3.consts.ACTIVE_SELECTION_BOX_COLOR_VECTOR);
        this.fastenerHoverHelper.setActivePanelToExtrusionSideConnections(selectedConnection, allConnections);
        if (isOrderCompleted) {
            return;
        }
        const widgetPosition = utils_2.Utils.positionToScreenPosition(selectedFastener.getWorldPosition(tempVector1), this.getCamera());
        if (!isOrderCompleted) {
            this.sendSphereData(selectedConnection.uuid, widgetPosition.x, widgetPosition.y);
        }
    }
    // eslint-disable-next-line react/no-unused-class-component-methods
    getClosestIntersectionByOuterBox() {
        let closestIntersection = null;
        const rayCaster = this.getRaycaster();
        rayCaster.setFromCamera(this.getMouse(), this.getCamera());
        this.getScene().children.forEach((child) => {
            const baseObject = child;
            if (!baseObject.isCustomObject) {
                return;
            }
            const intersection = rayCaster.intersectObject(baseObject.outerBox)[0];
            if (!intersection) {
                return;
            }
            const isIntersectionCloser = !closestIntersection || intersection.distance < closestIntersection.distance;
            if (isIntersectionCloser) {
                closestIntersection = intersection;
            }
        });
        return closestIntersection;
    }
    selectObjects(event) {
        var _a, _b;
        const customObject = (_b = (_a = this.getObjectIntersections(event)) === null || _a === void 0 ? void 0 : _a.customObject) === null || _b === void 0 ? void 0 : _b.object.parent;
        if (!customObject) {
            // eslint-disable-next-line no-unused-expressions
            !event.ctrlKey && this.designProMain.selectionTool.unselectAll();
            return;
        }
        const clickedOnAlreadySelectedObject = this.selectedObjects.includes(customObject);
        if (event.ctrlKey) {
            if (clickedOnAlreadySelectedObject) {
                this.designProMain.selectionTool.unselectObject(customObject);
            }
            else {
                this.designProMain.selectionTool.selectObjects([customObject]);
            }
        }
        else {
            this.designProMain.selectionTool.unselectAll();
            this.designProMain.selectionTool.selectObjects([customObject]);
        }
    }
    drawBalloons(camera, inclusions) {
        if (this.props.bom) {
            this.balloonsManager.addBalloonsToScene(camera, this.props.bom, inclusions);
        }
    }
    clearBalloons() {
        this.balloonsManager.removeBalloonsFromScene();
    }
    takePanelScreenShots() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.screenShotManager.takePanelScreenShots(this.props.bom);
        });
    }
    takeProjectsDimensionsScreenShots() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.screenShotManager.takeProjectsDimensionsScreenShots();
        });
    }
    // eslint-disable-next-line class-methods-use-this
    sendSphereData(sphereId, x, y) {
        const itemData = {
            uuid: sphereId,
            x,
            y,
        };
        document.body.dispatchEvent((0, events_1.selectFastenerEvent)(itemData));
    }
    detectIntersection(event, object, recursive = false) {
        if (object) {
            const rect = this.getRendererDOMElement().getBoundingClientRect();
            const mouse = new three_1.Vector2();
            mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
            mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
            this.raycaster = new three_1.Raycaster();
            this.raycaster.params.Line = { threshold: 0.1 };
            this.raycaster.setFromCamera(mouse, this.getCamera());
            return this.raycaster.intersectObject(object, recursive);
        }
        return [];
    }
    // eslint-disable-next-line react/no-unused-class-component-methods
    toggleAnimationMode() {
        if (!this.shouldAnimate) {
            this.shouldAnimate = true;
            this.animate();
        }
        else {
            cancelAnimationFrame(this.requestAnimationFrameId);
            this.shouldAnimate = false;
        }
    }
    maybeAllPartsBoundingBox(includeInsertingObject = false) {
        const box = new three_1.Box3();
        this.getScene().children.forEach((obj) => {
            var _a;
            if (obj instanceof classes_1.BaseObject3D &&
                obj.isCustomObject &&
                (obj.uuid !== ((_a = this.designProMain.scalingTool.getObject()) === null || _a === void 0 ? void 0 : _a.uuid) || includeInsertingObject)) {
                box.union(utils_2.Utils.getAABBox(obj, true));
            }
        });
        return box.isEmpty() ? null : box;
    }
    updateBuildPlanePosition(includeInsertingObject = false) {
        const optBox = this.maybeAllPartsBoundingBox(includeInsertingObject);
        if (optBox) {
            this.moveBuildPlaneToZCoord(optBox.max.z);
        }
    }
    moveBuildPlaneToZCoord(zCoord) {
        // eslint-disable-next-line no-param-reassign
        zCoord = Number.isFinite(zCoord) ? zCoord : 0;
        this.getGrid().setBuildPlaneVerticalPosition(zCoord);
        this.slidePlane.position.setZ(zCoord);
    }
    // eslint-disable-next-line react/no-unused-class-component-methods
    static get instance() {
        // eslint-disable-next-line no-underscore-dangle
        return Viewer._instance;
    }
    // eslint-disable-next-line react/no-unused-class-component-methods
    setIsImperialMeasurementUnits(isImperial) {
        if (isImperial === this.isImperialMeasurementUsed) {
            return;
        }
        this.isImperialMeasurementUsed = isImperial;
        let newExtrudeStep;
        if (!isImperial) {
            this.updateGridDivisions(consts_3.gridScaleStates[this.currentGridScaleState].cellSizeSI, consts_3.gridScaleStates[this.currentGridScaleState].divisionsPerCellSI);
            newExtrudeStep = consts_3.consts.DEFAULT_EXTRUDE_STEP_SI;
        }
        else {
            this.updateGridDivisions(consts_3.gridScaleStates[this.currentGridScaleState].cellSize, consts_3.gridScaleStates[this.currentGridScaleState].divisionsPerCell);
            newExtrudeStep = consts_3.consts.DEFAULT_EXTRUDE_STEP;
        }
        this.designProMain.transformControlsInitial.setScaleSnap(newExtrudeStep);
        this.designProMain.transformControlsInitial.setTranslationSnap(newExtrudeStep);
        this.updateViewer();
        document.body.dispatchEvent((0, events_1.measurementUnitChangedEvent)(isImperial));
    }
    // eslint-disable-next-line react/no-unused-class-component-methods
    scheduleTakeScreenshot() {
        if (this.screenshotTimerId) {
            return;
        }
        this.screenshotTimerId = setTimeout(() => __awaiter(this, void 0, void 0, function* () {
            yield this.makeScreeenshot();
            this.clearScreenshotTimeout();
        }), consts_3.consts.TAKE_SCREENSHOT_TIMEOUT);
    }
    makeScreeenshot() {
        return __awaiter(this, void 0, void 0, function* () {
            const blobScreenshots = yield (0, screenshots_1.default)(this, consts_3.consts.ISOMETRIC_SCREENSHOT_SIDE_LENGTH_PX, {
                isometric: true,
            });
            if (blobScreenshots.isometric) {
                const screenshot = yield (0, utils_1.blobToBase64)(blobScreenshots.isometric);
                document.body.dispatchEvent((0, events_1.takeIsometricScreenshotEvent)(screenshot));
            }
        });
    }
    makeScreenshotImmediately(onlyIfTimerExists = true) {
        return __awaiter(this, void 0, void 0, function* () {
            if (onlyIfTimerExists && !this.screenshotTimerId) {
                return;
            }
            this.makeScreeenshot();
            this.clearScreenshotTimeout();
        });
    }
    clearScreenshotTimeout() {
        if (!this.screenshotTimerId) {
            return;
        }
        clearTimeout(this.screenshotTimerId);
        this.screenshotTimerId = null;
    }
    recalculateGridScale() {
        tempVector1.set(0, 0, -1);
        tempVector2.set(0, 0, this.gridControlsHelper.position.z);
        tempPlane.setFromNormalAndCoplanarPoint(tempVector1, tempVector2);
        tempLine.start.copy(this.camera.position);
        tempLine.end.copy(tempVector1.addVectors(this.camera.position, this.camera.getWorldDirection(tempVector2).multiplyScalar(10000)));
        tempPlane.intersectLine(tempLine, tempVector2);
        const distanceFromCameraToPlane = tempVector2.distanceTo(this.camera.position) / this.camera.zoom;
        for (let i = 0; i < consts_3.gridScaleStates.length; i += 1) {
            if (distanceFromCameraToPlane <= consts_3.gridScaleStates[i].maxDistance) {
                if (this.currentGridScaleState === i) {
                    break;
                }
                if (this.isImperialMeasurementUsed) {
                    this.updateGridDivisions(consts_3.gridScaleStates[i].cellSize, consts_3.gridScaleStates[i].divisionsPerCell);
                }
                else {
                    this.updateGridDivisions(consts_3.gridScaleStates[i].cellSizeSI, consts_3.gridScaleStates[i].divisionsPerCellSI);
                }
                this.currentGridScaleState = i;
                break;
            }
        }
    }
    updateGridDivisions(bigCellSize, bidCellDivisions) {
        var _a, _b, _c, _d;
        const zCoord = this.getGrid().position.z;
        const bbox = this.maybeAllPartsBoundingBox(false);
        const maxOffset = Math.max(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-non-null-asserted-optional-chain
        Math.abs((_a = bbox === null || bbox === void 0 ? void 0 : bbox.min) === null || _a === void 0 ? void 0 : _a.x) * 2 || 0, 
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-non-null-asserted-optional-chain
        Math.abs((_b = bbox === null || bbox === void 0 ? void 0 : bbox.min) === null || _b === void 0 ? void 0 : _b.y) * 2 || 0, 
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-non-null-asserted-optional-chain
        Math.abs((_c = bbox === null || bbox === void 0 ? void 0 : bbox.max) === null || _c === void 0 ? void 0 : _c.x) * 2 || 0, 
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-non-null-asserted-optional-chain
        Math.abs((_d = bbox === null || bbox === void 0 ? void 0 : bbox.max) === null || _d === void 0 ? void 0 : _d.y) * 2 || 0, this.isImperialMeasurementUsed ? consts_3.consts.DEFAULT_GRID_SIZE : consts_3.consts.DEFAULT_GRID_SIZE_SI);
        this.gridControlsHelper.removeFromParent();
        this.gridControlsHelper = new classes_1.GridControlsHelper(this, bigCellSize, bigCellSize, bidCellDivisions);
        this.gridControlsHelper.setBuildPlaneSize(maxOffset / 2);
        this.gridControlsHelper.position.setZ(zCoord);
        this.scene.add(this.gridControlsHelper);
    }
    // eslint-disable-next-line class-methods-use-this
    onInformationAboutBuiltInFastenersGot(e) {
        const { user, projectId, callUpdateFastenersToBOM } = this.props;
        Promise.all(e.detail.map((connectionData) => __awaiter(this, void 0, void 0, function* () {
            const connection = this.designProMain.connectionManager.getConnectionByUUID(connectionData.connectionUuid);
            if (!connection) {
                return undefined;
            }
            if (connectionData.hasFasteners) {
                if (connectionData.itemNumber) {
                    const connectionObject = yield (0, FastenersUtils_1.updateFastenersForConnectionByUUID)(connectionData.connectionUuid, connectionData.itemNumber);
                    if (connectionObject) {
                        this.collisionProcessor.updateCollisionsForObjectsAndConnections([], [connectionObject]);
                    }
                    const metadata = connectionObject === null || connectionObject === void 0 ? void 0 : connectionObject.getFastenersMetadata();
                    return {
                        metadata,
                        uuid: connectionData.connectionUuid,
                        userId: user === null || user === void 0 ? void 0 : user.id,
                        projectId,
                    };
                }
            }
            else {
                (0, FastenersUtils_1.removeFastenersForConnectionByUUID)(connectionData.connectionUuid);
            }
            return undefined;
        }))).then((updateDataList) => {
            const payload = updateDataList.filter((item) => !!item);
            if (payload.length > 0) {
                callUpdateFastenersToBOM(payload);
            }
        });
    }
    // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-unused-vars, react/no-unused-class-component-methods
    setProjectOnScene(allProjectItems) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.designProMain.refreshScene();
            const projectItems = allProjectItems.filter((item) => item.panelSize &&
                item.panelSize.x > 0 &&
                item.panelSize.y > 0 &&
                item.panelSize.z > 0 &&
                !item.numberOfFasteners &&
                !item.manuallyAdded);
            const catalogItems = projectItems
                .map((projectItem) => projectItem.item)
                .filter((currentType, index, array) => {
                return array.findIndex((itemType) => itemType.item_number === currentType.item_number) === index;
            });
            const objects = [];
            yield this.reportProjectLoadingStage('models');
            const models = yield this.designProMain.loadModels(catalogItems);
            projectItems.forEach((projectItem) => {
                var _a, _b, _c, _d;
                const model = models.find((currentModel) => { var _a; return ((_a = currentModel === null || currentModel === void 0 ? void 0 : currentModel.partDetails) === null || _a === void 0 ? void 0 : _a.itemNumber) === projectItem.item.item_number; });
                if (!model) {
                    return;
                }
                const object = model.clone();
                object.uuid = projectItem.uuid;
                object.initBoxes();
                this.scene.add(object);
                if ((_a = projectItem.cutContour) === null || _a === void 0 ? void 0 : _a.length) {
                    if (projectItem.autoCutouts && projectItem.panelSize) {
                        object.setSize(new three_1.Vector3(projectItem.panelSize.x, projectItem.panelSize.y, projectItem.panelSize.z));
                    }
                    const panelObject = object;
                    const cutoutScale = projectItem.autoCutouts ? object.scale : new three_1.Vector3(1, 1, 1);
                    const contourPoints = projectItem.cutContour.map((point) => new three_1.Vector3(point.x, point.y, point.z).divide(cutoutScale));
                    const holes = ((_b = projectItem.holeContours) !== null && _b !== void 0 ? _b : []).map((hole) => hole.map((point) => new three_1.Vector3(point.x, point.y, point.z).divide(cutoutScale)));
                    const extrudeNormal = projectItem.autoCutouts ? consts_3.consts.DP_UP_DIR : panelObject.directionNormal;
                    panelObject.applyExtrudeGeometry(contourPoints, extrudeNormal, holes);
                    panelObject.autoCutouts = Boolean(projectItem.autoCutouts);
                }
                if (projectItem.item.is_scalable && !((_c = projectItem.cutContour) === null || _c === void 0 ? void 0 : _c.length)) {
                    object.setSize(tempVector1.set(projectItem.panelSize.x, projectItem.panelSize.y, projectItem.panelSize.z));
                }
                object.setRotation(tempQuaternion.set(projectItem.rotation.x, projectItem.rotation.y, projectItem.rotation.z, projectItem.rotation.w));
                object.setPosition(tempVector1.set(projectItem.position.x, projectItem.position.y, projectItem.position.z));
                // flip only object metadata because flip rotation is just a part of all object rotations
                if (projectItem.hasSwappedMetadataPoints) {
                    object.swapMetadataPoints();
                }
                this.collisionProcessor.notifyObjectAdded(object);
                if (projectItem.slicePlanes.length) {
                    const mainConnectedItem = projectItem.connectionItems.find((item) => {
                        return item.isMain;
                    });
                    object.scalingAngle = (_d = mainConnectedItem === null || mainConnectedItem === void 0 ? void 0 : mainConnectedItem.connectionExtrusionAngle) !== null && _d !== void 0 ? _d : 0;
                    const slicingTool = new SlicingTool_3d_1.default(object);
                    const planes = projectItem.slicePlanes.map((plane) => new three_1.Plane(new three_1.Vector3(plane.normal.x, plane.normal.y, plane.normal.z), plane.constant));
                    slicingTool.cutWithPlanes(planes);
                }
                objects.push(object);
            });
            const restoreConnections = [];
            // wait while items data is not loaded
            const sleep = (ms) => {
                // eslint-disable-next-line no-promise-executor-return
                return new Promise((resolve) => setTimeout(resolve, ms));
            };
            // eslint-disable-next-line react/destructuring-assignment
            while (!this.props.catalogItems.length && this.props.catalogLoadingState !== types_1.LOADING_STATE.FAILED) {
                // eslint-disable-next-line no-await-in-loop
                yield sleep(100);
            }
            if (this.props.catalogLoadingState === types_1.LOADING_STATE.FAILED) {
                throw new Error('Catalog failed to load');
            }
            yield this.reportProjectLoadingStage('connections');
            objects.forEach((object) => {
                const mainProjectItem = projectItems.find((item) => item.uuid === object.uuid);
                if (!mainProjectItem) {
                    return;
                }
                mainProjectItem.connectionItems.forEach((mainConnectionItem) => {
                    var _a, _b;
                    if (!mainConnectionItem.isMain) {
                        return;
                    }
                    const connectedProjectItem = projectItems.find((projectItem) => projectItem.connectionItems.find((connectionItem) => {
                        var _a, _b;
                        return (((_a = connectionItem.connection) === null || _a === void 0 ? void 0 : _a.id) === ((_b = mainConnectionItem.connection) === null || _b === void 0 ? void 0 : _b.id) &&
                            connectionItem.projectItemId !== mainProjectItem.id);
                    }));
                    if (!connectedProjectItem) {
                        return;
                    }
                    const connectedConnectionItem = connectedProjectItem.connectionItems.find((connectionItem) => { var _a, _b; return ((_a = connectionItem.connection) === null || _a === void 0 ? void 0 : _a.id) === ((_b = mainConnectionItem.connection) === null || _b === void 0 ? void 0 : _b.id); });
                    if (!connectedConnectionItem) {
                        return;
                    }
                    const mainObject = object;
                    const connectedObject = this.getObjectById(connectedProjectItem.uuid);
                    const connectionId = (_a = mainConnectionItem.connection) === null || _a === void 0 ? void 0 : _a.uuid;
                    const fastenerProjectItems = connectionId
                        ? allProjectItems.filter((projectItem) => {
                            var _a, _b;
                            return ((((_a = projectItem.item.componentType) === null || _a === void 0 ? void 0 : _a.name) === types_1.COMPONENT_TYPE.FASTENER ||
                                ((_b = projectItem.item.componentType) === null || _b === void 0 ? void 0 : _b.name) === types_1.COMPONENT_TYPE.PANEL_GASKET) &&
                                projectItem.connectionItems.find((connectionItem) => {
                                    var _a;
                                    return ((_a = connectionItem.connection) === null || _a === void 0 ? void 0 : _a.uuid) === connectionId;
                                }));
                        })
                        : [];
                    // eslint-disable-next-line no-param-reassign
                    mainConnectionItem.uuid = mainObject.uuid;
                    connectedConnectionItem.uuid = connectedObject.uuid;
                    if ((_b = mainConnectionItem.connection) === null || _b === void 0 ? void 0 : _b.uuid) {
                        restoreConnections.push(this.designProMain.connectionManager.restoreConnection(mainObject, connectedObject, ConnectionManager_3d_1.default.cloneConnectionItem(mainConnectionItem), ConnectionManager_3d_1.default.cloneConnectionItem(connectedConnectionItem), mainConnectionItem.connection.connectionType.name, mainConnectionItem.connection.uuid, fastenerProjectItems));
                    }
                });
            });
            objects.forEach((object) => {
                this.collisionProcessor.updateCollisions(object);
            });
            yield Promise.all(restoreConnections).then((connectionObjects) => {
                this.collisionProcessor.updateCollisionsForObjectsAndConnections([], connectionObjects);
            });
            if ((_a = this.designProMain.scalingTool.slicingTool) === null || _a === void 0 ? void 0 : _a.clipMesh) {
                this.designProMain.scalingTool.slicingTool.resetClipMesh();
                this.designProMain.scalingTool.objectPosition = null;
                this.designProMain.scalingTool.initialSize = null;
            }
            this.designProMain.clearTools();
            this.designProMain.halfSideAngled = null;
            this.designProMain.drawingAngledLock = false;
            this.updateBuildPlanePosition();
            document.body.dispatchEvent((0, events_1.selectedObjectsChangedEvent)([]));
        });
    }
    startProjectItemsReplacementOnScene() {
        this.toggleAnimationMode();
    }
    stopProjectItemsReplacementOnScene() {
        this.toggleAnimationMode();
    }
    /**
     * This method takes necessary precautions per item after its replaced using below algorithm:
     * 1. Take the necessary precautions for the item after replacement.
     * 2. Notify collision processor about object addition (updation) and update the collisions.
     * @param itemWithNewLook   The item that got new look after replacement.
     * @param appliedLook       The new look that's been applied to the item.
     */
    takePostMakeoverPrecautionsPerItem(itemWithNewLook, appliedLook) {
        //   1.
        itemWithNewLook.takePostMakeoverPrecautions(appliedLook);
        //   2.
        this.collisionProcessor.notifyObjectAdded(itemWithNewLook);
        this.collisionProcessor.updateCollisions(itemWithNewLook);
    }
    replaceProjectItemsOnScene(replacementData) {
        return __awaiter(this, void 0, void 0, function* () {
            this.startProjectItemsReplacementOnScene();
            const { itemNumber: itemNumberOfReplacement, uuids: uuidsOfItemsToReplace } = replacementData;
            const catalogItemForItemNumber = this.props.catalogItems.find((catalogItem) => catalogItem.item_number === itemNumberOfReplacement);
            if (!catalogItemForItemNumber) {
                (0, events_1.showNotification)({
                    type: 'error',
                    message: `No catalog item found for the selected replacement`,
                });
                this.stopProjectItemsReplacementOnScene();
                return;
            }
            const [rawReplacement] = yield this.designProMain.loadModels([catalogItemForItemNumber]);
            if (!rawReplacement) {
                (0, events_1.showNotification)({
                    type: 'error',
                    message: `No model found for the selected replacement`,
                });
                this.stopProjectItemsReplacementOnScene();
                return;
            }
            // Do makeover of existing items on scene to make them look like replacement item
            // The existing items on scene will have references at many places hence their makeover is less complex than updating all references
            const itemsForMakeover = uuidsOfItemsToReplace.reduce((foundItemsOnScene, uuid) => {
                const itemOnScene = utils_2.Utils.getObjectByUUID(this.scene, uuid);
                if (!itemOnScene) {
                    (0, events_1.showNotification)({
                        type: 'warning',
                        message: `Item with uuid{${uuid}} was not found on the scene`,
                    });
                }
                else {
                    foundItemsOnScene.push(itemOnScene);
                }
                return foundItemsOnScene;
            }, []);
            // Follow the algorithm below for the makeover of each of the items to be replaced
            // Algorithm:
            //   1. Unselect the makeover candidate.
            //   2. Get cooked replacement copy to give new look the makeover candidate.
            //   3. Give the new look to the makeover candidate.
            //   4. Take necessary post makeover precautions.
            //   5. Reselect the makeover candidate item if it was selected earlier to preserve previous selection.
            itemsForMakeover.forEach((itemForMakeover) => {
                //   1.
                itemForMakeover.unselect();
                //   2.
                const cookedReplacement = rawReplacement.getCookedReplacementCopy(itemForMakeover);
                //   3.
                itemForMakeover.acquireNewLook(cookedReplacement);
                //   4.
                this.takePostMakeoverPrecautionsPerItem(itemForMakeover, cookedReplacement);
                //   5.
                if (this.selectedObjectUUIDs.includes(itemForMakeover.uuid)) {
                    itemForMakeover.select();
                }
            });
            this.stopProjectItemsReplacementOnScene();
            (0, PlasticPanelCutouts_3d_1.refreshPlasticPanels)(this);
        });
    }
    render() {
        return react_1.default.createElement("canvas", { id: consts_3.consts.CANVAS_ID, className: Cad3d_scss_1.default.canvasViewer, onMouseEnter: () => this.updateCursorForTool() });
    }
}
// eslint-disable-next-line react/static-property-placement
Viewer.defaultProps = {
    isOrderCompleted: false,
    isProjectArchived: false,
    isProjectViewOnly: true,
    isDefaultFastenersWidgetShown: false,
    isItemReplacementWidgetShown: false,
};
exports.default = Viewer;
